import Controller from './controller'
import Modal from './modal_controller'

export default class extends Controller {
  initialize() {
    this.open = this.open.bind(this)
    this.id ||= this.data.get('id')
  }

  open(ev) {
    ev.preventDefault()

    this.id ||= this.data.get('id')

    // If this modal link is inside a modal, close that modal when opening this new one
    const modalTarget = this.element.closest('[data-controller="modal"]')
    if (modalTarget) {
      const modal = this.application.getControllerForElementAndIdentifier(modalTarget, 'modal')
      modal.close()
    }

    if (Modal.instances[this.id]) {
      Modal.instances[this.id].open()
      this.modalTarget ||= Modal.instances[this.id].element
    } else {
      this.createModal()
    }
  }

  createModal() {
    const template = this.getTemplateTarget()
    this.modalTarget = document.importNode(template.content, true).firstElementChild

    // Modals open automatically when Stimulus finds them in the DOM (see modal_controller)
    document.body.appendChild(this.modalTarget)
    this.processContent()
  }

  processContent() {
    // Scale SVGs added to DOM for IE11
    if (window.scaleSvgs) {
      window.scaleSvgs(this.modalTarget)
    }

    // Polyfill picture and srcset in new content
    if (window.picturefill) {
      window.picturefill()
    }
  }

  getTemplateTarget() {
    return document.getElementById(this.id)
  }
}
